module.exports = {
  search: 'Tìm kiếm',
  isCustomer: 'Khách hàng',
  isBookingAgent: 'Đại lý đặt chỗ',
  isOverseaAgent: 'Đại lý cảng đích',
  isDesignationAgent: 'Đại lý vận chuyển được chỉ định	　',
  isLocalAgent: 'Đại lý địa phương',
  isSeaCmp: 'Công ty tàu　',
  isAirCmp: 'Hãng hàng không',
  isCustomsBroker: 'Công ty khai báo hải quan',
  isTruckCmp: 'Công ty xe tải',
  isWarehouse: 'Kho hàng',
  isGlobal: 'Tập đoàn',
  isShipper: 'Người gửi hàng',
  isConsignee: 'Người nhận hàng',
  isNotify: 'Người thông báo',
  isActive: 'Có hiệu lực không',
  isShowHq: 'có hiển thị khách hàng HQ không',
  btMerge: 'Hợp nhất',
  btnRemove: 'Xóa',
  btnAdd: 'Thêm',
  btnRefresh: 'Làm mới',
  btnLookUp: 'Xem',
  totalCount: 'Tổng số bản ghi',
  btAudit: 'Kiểm duyệt',
  btCacelAudit: 'Hủy kiểm duyệt',
  approvedState: 'Trạng thái kiểm duyệt',
  approvedBy: 'Người kiểm duyệt',
  dateApproved: 'Ngày kiểm duyệt',
  dateCreated: 'Ngày tạo',
  to: 'Đến',
  dateModified: 'Ngày sửa đổi',
  parter: 'Đối tác',
  customerType: 'Loại khách hàng',
  sales: 'Bán hàng',
  customerLevel: 'Cấp độ khách hàng',
  whetherReview: 'Đã kiểm duyệt chưa',
  whetherEffective: 'Có hiệu lực không',
  amount: 'Số điều',
  query: 'Truy vấn',
  add: 'Thêm mới',
  delete: 'Xóa',
  view: 'Xem',
  review: 'Kiểm duyệt',
  batchPrint: 'In hàng loạt',
  B2BRegistrationInvitation: 'Lời mời đăng ký B2B',
  freightAuthorization: 'Ủy quyền giá cước',
  combine: 'Hợp nhất',
  batchEditInvoiceHeader: 'Thay đổi hàng loạt tiêu đề hóa đơn',
  batchEditSalers: 'Thay đổi hàng loạt bán hàng',
  batchEditServer: 'Thay đổi hàng loạt nhân viên dịch vụ',
  templateDownload: 'Tải mẫu',
  import: 'Nhập khẩu',
  exportAgentList: 'Xuất danh sách đại lý',
  downloadImportTemplate: 'Tải mẫu nhập khẩu',
  downloadImportResults: 'Tải kết quả nhập khẩu',
  number: 'Mã số',
  abbreviation: 'Tên viết tắt',
  code: 'Mã code',
  chineseName: 'Tên tiếng Trung',
  englishName: 'Tên tiếng Anh',
  branchCompany: 'Chi nhánh',
  creator: 'Người tạo',
  creationDate: 'Ngày tạo',
  modifier: 'Người sửa',
  modificationDate: 'Ngày sửa',
  ecommerceCustomer: 'Khách hàng thương mại điện tử',
  day30day: '30 ngày (phiếu)',
  day60day: '60 ngày (phiếu)',
  day90day: '90 ngày (phiếu)',
  gt90day: 'Trên 90 ngày (phiếu)',
  all: 'Tất cả',
  yes: 'Có',
  no: 'Không',
  return: 'Quay lại',
  edit: 'Chỉnh sửa',
  save: 'Lưu',
  cancel: 'Hủy',
  basicInformation: 'Thông tin cơ bản',
  contacts: 'Người liên hệ',
  customer: 'Khách hàng',
  creditAccount: 'Tín dụng tài khoản',
  contractNumber: 'Số hợp đồng',
  documentation: 'Tài liệu',
  doorInformation: 'TT ĐGN',
  specialRequirements: 'Yêu cầu đặc biệt',
  invoicingRequirements: 'Yêu cầu xuất hóa đơn',
  destinationPortHandlingAgent: 'Đại lý thao tác cảng đích',
  destinationNominatedAgent: 'Đại lý hàng chỉ định cảng đích',
  portLocation: 'Cảng hiện tại',
  spaceCarrier: 'Người chở chỗ',
  spaceAgent: 'Đại lý chỗ',
  warehouseInformation: 'Thông tin kho hàng',
  EDIConfiguration: 'Cấu hình EDI',
  AddressInformation: 'Thông tin địa chỉ',
  BranchAuthorization: 'Ủy quyền chi nhánh',
  activity: 'Hoạt động',
  crossTenantAuthorize: 'Ủy thác đa Tenant',
  crossTenantAuthorizeAgreement: 'Thỏa thuận ủy thác đa Tenant',
  agree: 'Đồng ý',
  theOtherPlatformID: 'ID nền tảng đối tác',
  seaCmpAgent: 'Đại lý tàu',
  destinationAgent: 'Đại lý cảng đích',
  nominatedAgent: 'Đại lý hàng hóa chỉ định',
  localAgent: 'Đại lý địa phương',
  settlementAgent: 'Đại lý thanh toán',
  shippingCompany: 'Công ty tàu biển',
  airlineCompany: 'Hãng hàng không',
  customsBroker: 'Công ty khai báo hải quan',
  warehouse: 'Kho hàng',
  truckCompany: 'Công ty xe tải',
  shipper: 'Người gửi hàng',
  consignee: 'Người nhận hàng',
  notify: 'Người thông báo',
  chkMustInputScn: 'Bắt buộc điền thông tin người gửi/nhận/thông báo?',
  others: 'Khác',
  relatedBusinessType: 'Loại hình nghiệp vụ liên quan',
  oceanExport: 'Xuất khẩu đường biển',
  oceanImport: 'Nhập khẩu đường biển',
  airExport: 'Xuất khẩu đường hàng không',
  airImport: 'Nhập khẩu đường hàng không',
  relatedBranch: 'Chi nhánh liên kết',
  paymentType: 'Loại hình thanh toán',
  whetherCollection: 'Có phải thu hộ không?',
  usingSettlementAgent: 'Sử dụng đại lý thanh toán',
  country: 'Quốc gia (vùng lãnh thổ)',
  province: 'Tỉnh',
  city: 'Thành phố',
  district: 'Quận/Huyện',
  address: 'Địa chỉ',
  postCode: 'Mã bưu điện',
  telephone: 'Điện thoại',
  fax: 'Fax',
  website: 'Website',
  rmbAccount: 'Tài khoản RMB',
  usdAccount: 'Tài khoản USD',
  taxRate: 'Thuế suất',
  additionalDescription: 'Ghi chú bổ sung',
  tel: 'Điện thoại',
  sapCustomerCode: 'Mã khách hàng SAP',
  sapSupplierCode: 'Mã nhà cung cấp SAP',
  isSignContract: 'Đã ký hợp đồng chưa?',
  ContractStatus: 'Tình trạng ký kết',
  ClientContractStatus: 'Tình trạng ký HĐ khách hàng',
  SupplierContractStatus: 'Tình trạng ký HĐ nhà cung cấp',
  OverseasAgencyContractStatus: 'Tình trạng ký HĐ đại lý nước ngoài',
  OtherContractStatus: 'Tình trạng ký HĐ khác',
  ContractApproxStatus: 'Tình trạng số hợp đồng',
  name: 'Người liên hệ',
  function: 'Chức năng',
  isDefault: 'Có mặc định không?',
  Email: 'Địa chỉ email',
  mobile: 'Điện thoại di động',
  pushNode: 'Nút đẩy',
  pushMode: 'Phương thức đẩy',
  remark: 'Ghi chú',
  airline: 'Tuyến đường',
  departmentBelonging: 'Bộ phận quản lý',
  peers: 'Đồng nghiệp',
  isPeers: 'Có phải đồng nghiệp không',
  introductionDate: 'Ngày kích hoạt i-trace',
  customerSpace1: 'Loại hàng nhận',
  customerSpace2: 'Hàng chỉ định',
  customerSpace3: 'Hàng tự nhận',
  portOfDestination: 'Cảng đến',
  theCorrespondingServicePartners: 'Nhân viên dịch vụ tương ứng với đối tác',
  theCorrespondingServiceOverseaAgent: 'Dịch vụ khách hàng nước ngoài tương ứng với đại lý cảng đến',
  positionType: 'Loại vị trí',
  businessType: 'Loại nghiệp vụ',
  user: 'Người dùng',
  creditControlSettings: 'Thiết lập kiểm soát tín dụng',
  defaultCreditInfoSettings: 'Bảo trì kiểm soát tín dụng mặc định',
  defaultCreditInfoNote: 'Lưu ý: Sau khi bảo trì kiểm soát tín dụng mặc định, hệ thống sẽ lấy nội dung kiểm soát tín dụng hiện tại khi tạo đối tác mới!',
  dateType: 'Loại ngày',
  settlementMethod: 'Phương thức thanh toán',
  monthlySettlement: 'Thanh toán theo tháng',
  blacklist: 'Danh sách đen',
  accountPeriod: 'Kỳ hạn thanh toán',
  limit: 'Hạn mức',
  settlementType: 'Loại thanh toán',
  settlementByBill: 'Thanh toán bằng vé',
  settlementNotByBill: 'Thanh toán không bằng vé',
  revenueAndExpenditureType: 'Loại thu chi',
  collections: 'Thu tiền',
  payment: 'Chi tiền',
  depositAmount: 'Số tiền đặt cọc',
  revenueAndExpenditureDate: 'Ngày thu chi',
  revenueAndExpenditureMethod: 'Phương thức thu chi',
  cash: 'Tiền mặt',
  depositCurrency: 'Loại tiền đặt cọc',
  day: 'Ngày',
  week: 'Tuần',
  month: 'Tháng',
  space1: 'Ngày nghiệp vụ',
  space2: 'Ngày hóa đơn',
  space3: 'Tính theo tuần',
  space4: 'Ngày chỉ định hàng tháng',
  space5: 'Thanh toán nửa tháng',
  space6: 'Séc',
  space7: 'Chuyển khoản',
  space8: 'Kỳ phiếu',
  space9: 'Thu hộ và chi hộ',
  space10: 'Hạn mức tín dụng ngân hàng',
  effectiveDate: 'Ngày hiệu lực',
  expiryDate: 'Ngày hết hạn',
  fileNumber: 'Số hiệu tài liệu',
  remarks: 'Ghi chú',
  documentSize: 'Số lượng tệp đính kèm',
  attachment: 'Tệp đính kèm',
  uploadFile: 'Tải lên tệp',
  upload: 'Tải lên',
  download: 'Tải xuống',
  fileName: 'Tên tệp',
  fileType: 'Loại tệp',
  fileFormat: 'Định dạng tệp',
  fileSize: 'Kích thước tệp',
  viewFile: 'Xem tệp',
  whetherUploadContractAttachment: 'Có tải lên tệp đính kèm hợp đồng không?',
  doorName: 'Tên điểm giao dịch',
  contact: 'Người liên hệ',
  doorAddress: 'Địa chỉ điểm giao dịch',
  canOverPrice: 'Có thể khai cao không?',
  invoicingMethod: 'Phương thức xuất hóa đơn',
  invoicingPerBill: 'Xuất hóa đơn đơn lẻ',
  invoicingPerMonth: 'Xuất hóa đơn theo tháng',
  invoicingNote: 'Ghi chú hóa đơn',
  invoiceHeader: 'Người nhận hóa đơn',
  registrationNumber: 'Mã số thuế',
  invoiceAddress: 'Địa chỉ hóa đơn',
  bankOfInvoiceHeader: 'Ngân hàng người nhận hóa đơn',
  operation: 'Thao tác',
  bankMaintenance: 'Bảo trì ngân hàng',
  confirm: 'Xác nhận',
  currency: 'Loại tiền tệ',
  bankName: 'Tên ngân hàng',
  bankAccount: 'Số tài khoản ngân hàng',
  swiftCode: 'Mã SWIFT',
  paymentLine: 'Mã liên hàng',
  forecastReceivingEmail: 'Địa chỉ email nhận dự báo',
  oceanBillOfLadingAddress: 'Địa chỉ vận đơn đường biển',
  airBillOfLadingAddress: 'Địa chỉ vận đơn đường hàng không',
  agentLevel: 'Cấp độ đại lý',
  networkManager: 'Người phụ trách mạng lưới',
  billingAddress: 'Địa chỉ hóa đơn',
  network: 'Mạng lưới',
  portName: 'Tên cảng',
  carrier: 'Người vận chuyển',
  carrierType: 'Loại người vận chuyển',
  bookingMethod: 'Phương thức đặt chỗ',
  choose: '-Vui lòng chọn-',
  bookingAgent: 'Đại lý đặt chỗ',
  ediSenderCode: 'Mã người gửi EDI',
  ediReceiverCode: 'Mã người nhận EDI',
  bookingPartyCode: 'Mã người đặt chỗ',
  loadFailed: 'Tải thất bại',
  deleteing: 'Đang xóa....',
  deleted: 'Đã xóa',
  occurredError: 'Lỗi phát sinh',
  deleteConfirmTitle: 'Xác nhận xóa',
  deleteConfirmMessage: 'Bạn có chắc chắn muốn xóa dữ liệu này không?',
  formatInformation: 'Thông tin định dạng',
  notFormatInformation: 'Thông tin không định dạng',
  formatSynchronize: 'Đồng bộ thông tin định dạng sang thông tin không định dạng',
  codeAbbreviation: 'Mã viết tắt',
  enterpriseCode: 'Mã doanh nghiệp',
  partnerName: 'Tên',
  detailAddress: 'Địa chỉ chi tiết',
  phone: 'Số điện thoại',
  email: 'Địa chỉ EMAIL',
  relexNumber: 'Số telex',
  cityName: 'Tên thành phố',
  provinceCode: 'Mã tỉnh',
  provinceName: 'Tên tỉnh',
  postalCode: 'Mã bưu điện',
  countryCode: 'Mã quốc gia',
  aeoEnterpriseCode: 'Mã doanh nghiệp AEO',
  specificContactName: 'Tên người liên hệ cụ thể',
  specificContactPhone: 'Số điện thoại người liên hệ cụ thể',
  specificContactAddress: 'Địa chỉ EMAIL người liên hệ cụ thể',
  specificContactRelexNumber: 'Số telex người liên hệ cụ thể',
  WarehouseType: 'Loại kho',
  WarehouseName: 'Tên kho',
  WarehouseAddress: 'Địa chỉ kho',
  WarehouseMap: 'Bản đồ kho',
  PleaseSelect: 'Vui lòng chọn',
  Number: 'Số vé',
  GreaterThan: 'Lớn hơn',
  LessThan: 'Nhỏ hơn',
  EqualTo: 'Bằng',
  WhetherToPushSOPStatus: 'Có đẩy trạng thái SOP không?',
  Push: 'Đẩy',
  NoPushing: 'Không đẩy',
  portAgent: 'Đại lý cửa khẩu',
  forwardingAgent: 'Đại lý vận chuyển',
  loadingPlaceCompany: 'Công ty địa điểm xếp hàng',
  signBillPlaceCompany: 'Công ty địa điểm ký đơn',
  dischargePortCompany: 'Công ty cảng dỡ hàng',
  destinationPortCompany: 'Công ty cảng đích',
  ParentCompany: 'Công ty mẹ',
  SelectFile: 'Chọn tệp',
  DeleteFile: 'Xóa tệp',
  Confirm: 'Xác nhận',
  Cancel: 'Hủy bỏ',
  FileName: 'Tên tệp',
  FileType: 'Loại tệp',
  FileSize: 'Kích thước tệp',
  Uploader: 'Người tải lên',
  UploadTime: 'Thời gian tải lên',
  UploadProgress: 'Tiến trình tải lên',
  DocumentType: 'Loại tài liệu',
  UnselectedContact: 'Chưa chọn liên hệ',
  PartnerNotSaved: 'Đối tác chưa lưu',
  UpdateMaterial: 'Tải lên tài liệu',
  DataNotSelected: 'Dữ liệu chưa chọn',
  RailwayExport: 'Xuất khẩu đường sắt',
  RefuseRemark: 'Lý do từ chối',
  Refuser: 'Người từ chối',
  RefuseDate: 'Ngày từ chối',
  REMARKS: 'Ghi chú bổ sung',
  InternalRemark: 'Ghi chú nội trang',
  supplyChainLines: 'Tuyến chuỗi cung ứng',
  Middleman: 'Nhà phân phối',
  Factory: 'Nhà máy',
  CompanyName: 'Tên công ty',
  Company: 'Công ty',
  contacts_name: 'Liên hệ',
  contacts_function: 'Chức năng',
  contacts_telephone: 'Điện thoại',
  contacts_email: 'Địa chỉ email',
  contacts_mobile: 'Điện thoại di động',
  contacts_remark: 'Ghi chú',
  credit_creditControlSettings: 'Thiết lập kiểm soát tín dụng',
  credit_dateType: 'Loại ngày',
  credit_creditControlSettings_date: 'Loại ngày thiết lập kiểm soát tín dụng',
  credit_creditControl_date: 'Loại ngày kiểm soát tín dụng',
  credit_settlementMethod: 'Phương thức thanh toán',
  credit_monthlySettlement: 'Thanh toán theo tháng',
  credit_blacklist: 'Danh sách đen',
  credit_accountPeriod: 'Kỳ hạn thanh toán',
  credit_limit: 'Hạn mức',
  credit_settlementType: 'Loại thanh toán',
  credit_settlementByBill: 'Thanh toán bằng hóa đơn',
  credit_settlementNotByBill: 'Thanh toán không dùng hóa đơn',
  credit_revenueAndExpenditureType: 'Loại thu chi',
  credit_collections: 'Thu tiền',
  credit_payment: 'Chi tiền',
  credit_depositAmount: 'Số tiền đặt cọc',
  credit_revenueAndExpenditureDate: 'Ngày thu chi',
  credit_revenueAndExpenditureMethod: 'Phương thức thu chi',
  credit_cash: 'Tiền mặt',
  credit_depositCurrency: 'Loại tiền đặt cọc',
  credit_additionalDescription: 'Ghi chú bổ sung',
  credit_day: 'Ngày',
  credit_week: 'Tuần',
  credit_month: 'Tháng',
  credit_space1: 'Ngày nghiệp vụ',
  credit_space2: 'Ngày hóa đơn',
  credit_space3: 'Tính theo tuần',
  credit_space4: 'Ngày chỉ định hàng tháng',
  credit_space5: 'Kết toán nửa tháng',
  credit_space6: 'Séc',
  credit_space7: 'Chuyển khoản',
  credit_space8: 'Kỳ phiếu',
  credit_space9: 'Thu hộ/Chi hộ',
  credit_space10: 'Tín dụng ngân hàng',
  credit_wtCreateCompany: 'Thêm đối tác đã xác thực nền tảng bằng một cú nhấp',
  partnerReview: 'Duyệt đối tác',
  partnerReviewed: 'Đối tác đã được duyệt',
  fillRejectReason: 'Vui lòng điền lý do từ chối',
  auditRejected: 'Đã từ chối duyệt',
  changeServicePersonnel: 'Thay đổi nhân viên phục vụ',
  userName: 'Tên người dùng',
  batchChangeSales: 'Thay đổi hàng loạt kết quả bán hàng',
  positionTypeNotSelected: 'Chưa chọn loại vị trí công việc.',
  multipleSameBusinessPosition: 'Tồn tại nhiều bản ghi vị trí nghiệp vụ giống nhau.',
  defaultValueNotEmpty: 'Giá trị mặc định không được để trống!',
  setInitialPassword: 'Thiết lập mật khẩu ban đầu',
  openB2BSettings: 'Mở thiết lập B2B',
  selectBookingAgent: 'Vui lòng chọn đại lý đặt chỗ tương ứng!',
  batchSelectBookingAgent: 'Vui lòng chọn hàng loạt đại lý đặt chỗ tương ứng!',
  modificationOfBookingAgents: 'Sửa đổi hàng loạt đại lý đặt chỗ',
  openB2BAccount: 'Kích hoạt tài khoản B2B',
  resetPassword: 'Đặt lại mật khẩu',
  b2bUsers: 'Người dùng B2B',
  selectNotOpenedB2BAccount: 'Vui lòng chọn liên hệ chưa kích hoạt tài khoản B2B.',
  emailAddressIsIllegal: 'Địa chỉ email không hợp lệ!',
  selectAnApprovedPartner: 'Vui lòng chọn đối tác đã được duyệt',
  inputAPassword: 'Vui lòng nhập mật khẩu!',
  accountOpenedSuccessfully: 'Kích hoạt tài khoản thành công!',
  selectAContact: 'Vui lòng chọn liên hệ',
  oneContactPasswordCanResetATime: 'Mỗi lần chỉ có thể đặt lại mật khẩu cho một liên hệ',
  notOpenedB2BAccount: 'Liên hệ này chưa kích hoạt tài khoản B2B',
  confirmToReset: 'Xác nhận đặt lại',
  yourLoginPassword: 'mật khẩu đăng nhập?',
  openResetPasswordLink: 'Đặt lại thành công, vui lòng mở liên kết đặt lại mật khẩu trong email để thực hiện.',
  batchModifyServicePersonnel: 'Thay đổi hàng loạt nhân viên phục vụ',
  exportModificationResults: 'Xuất kết quả thay đổi',
  partnerAbbreviation: 'Tên viết tắt đối tác',
  chineseNameOfPartner: 'Tên tiếng Trung của đối tác',
  servicePersonal: 'Nhân viên phục vụ',
  isItSuccessful: 'Có thành công không',
  enterUserInformation: 'Vui lòng nhập thông tin người dùng',
  selectAUserToModify: 'Vui lòng chọn người dùng cần sửa',
  modifyInvoicingHeader: 'Sửa tên trên hóa đơn',
  batchModifyInvoicingHeader: 'Thay đổi hàng loạt tên trên hóa đơn',
  enterBillingHeaderInformation: 'Vui lòng nhập thông tin tên trên hóa đơn',
  batchChangeSalesperson: 'Thay đổi hàng loạt nhân viên bán hàng',
  modifySalesperson: 'Sửa đổi nhân viên bán hàng',
  batchModifySalesperson: 'Chỉnh sửa hàng loạt nhân viên bán hàng',
  salesman: 'Nhân viên kinh doanh',
  selectRecordToExport: 'Vui lòng chọn bản ghi cần xuất!',
  mergedPartners: 'Đối tác hợp nhất',
  notPermissionEditOverseasAgent: 'Bạn không có quyền chỉnh sửa đại lý nước ngoài!',
  notPermissionEditCarrier: 'Bạn không có quyền chỉnh sửa người vận chuyển!',
  companyIsSettlementAgentFollowingPartners: 'Công ty này hiện là đại lý thanh toán của các đối tác sau',
  confirmDisassociateAndSaveModification: 'Xác nhận hủy liên kết và lưu thay đổi?',
  affiliatedBranch: 'Chi nhánh trực thuộc',
  contractAffiliatedBranch: 'Chi nhánh sở hữu hợp đồng',
  alreadyAPartner: 'Đã là đối tác chưa?',
  selectAPartner: 'Vui lòng chọn đối tác!',
  applicationSentSuccessfully: 'Đã gửi đơn thành công!',
  addPlatformCertificationPartners: 'Thêm đối tác được chứng nhận nền tảng, tương tác với "Wohang Home" cùng xây dựng hệ sinh thái logistics.',
  tariffLevelAuthorization: 'Ủy quyền cấp độ giá cước',
  fullContainerFreightRate: 'Giá FCL',
  lclFreightRate: 'Giá LCL',
  airFreightRate: 'Giá vận chuyển hàng không',
  fbaRate: 'Báo giá FBA',
  mergePartners: 'Hợp nhất đối tác',
  updateSupplierData: 'Cập nhật dữ liệu khách hàng/nhà cung cấp',
  maintainInformation: 'Bảo trì hàng loạt tín dụng',
  batchBlacklistSetting: 'Thiết lập danh sách đen hàng loạt',
  maintainDefaultCreditInfo: 'Tín dụng mặc định',
  freightFateLevelIsAuthorized: 'Ủy quyền cấp giá cước cho nhóm khách hàng, không phải cá nhân',
  servicePersonnelSettingNotEnabled: 'Chưa bật cài đặt nhân viên dịch vụ tương ứng với đối tác',
  deletedWithAdministratorPermission: 'Chỉ quản trị viên mới có quyền xóa!',
  partnerNotSelected: 'Chưa chọn đối tác.',
  partnerBeenUsedByBusiness: 'Đối tác đã được sử dụng trong nghiệp vụ.',
  mergedPartnerBeenAssociatedWithCRM: 'Đối tác hợp nhất đã liên kết CRM',
  mergedPartnerBeenAssociatedWithCRM1: 'Đối tác hợp nhất đã liên kết CRM, có {0} không? Đối tác sau khi hủy liên kết có thể xem tại menu "Thùng rác khách hàng".',
  mergedPartnerBeenAssociatedWithCRM2: 'Hủy liên kết cưỡng chế',
  removeAssociationWithPartner: 'Vui lòng vào [Bán hàng - Khách hàng nhóm] / [Bán hàng - Biển khách hàng] để xóa liên kết với đối tác.',
  partnersWithCustomerAttributeCanBeSelected: 'Chỉ được chọn đối tác có thuộc tính là khách hàng',
  partnersWithOverseaAgentAttributeCanBeSelected: 'Chỉ có thể chọn các đối tác có thuộc tính đại lý ở nước ngoài.',
  authorizationSucceeded: 'Ủy quyền thành công',
  groupCompaniesCannotBeMerged: 'Không thể hợp nhất tập đoàn!',
  chooseADifferentPartner: 'Vui lòng chọn đối tác khác nhau!',
  noAuthorityToAuditCustomerRolePartners: 'Bạn không có quyền duyệt đối tác vai trò khách hàng trong dữ liệu đã chọn!!!',
  noAuthorityToAuditSupplierRolePartners: 'Bạn không có quyền duyệt đối tác vai trò nhà cung cấp trong dữ liệu đã chọn!!!',
  vouchersBeenGeneratedContinue: 'Đã tạo chứng từ, có tiếp tục hợp nhất không?',
  mergeSuccessful: 'Hợp nhất thành công',
  uploadXLSFormatFile: 'Vui lòng tải lên file định dạng xls/xlsx!',
  updateSucceeded: 'Cập nhật thành công!',
  failedUpdateSupplierData: 'Cập nhật dữ liệu khách hàng/nhà cung cấp thất bại!',
  industrialAndCommercialInformationQuery: 'Tra cứu thông tin doanh nghiệp',
  fleetCode: 'Mã đội xe',
  platformSupplier: 'Nhà cung cấp nền tảng',
  ouJian: 'Oujian (phiên âm)',
  supplierPrincipal: 'Người phụ trách nhà cung cấp',
  crossTenantEntrustedBookingGeneralProtocol: 'Thỏa thuận chung về đặt chỗ vượt Tenant trên nền tảng CARGOWARE',
  traders: 'Thương nhân',
  shortNameCannotBeEmpty: 'Tên viết tắt không được để trống',
  oneBusinessTypeForCustomer: 'Phải chọn ít nhất một loại hình kinh doanh của khách hàng',
  customerAddressNotEmpty: 'Địa chỉ khách hàng không được để trống.',
  partnerRoleMustBeSelected: 'Phải chọn một vai trò đối tác',
  customerBusinessTypeMustBeSelected: 'Phải chọn một loại hình kinh doanh của khách hàng',
  usedByVoucherCannotModified: 'Đã được sử dụng bởi chứng từ, không thể chỉnh sửa',
  usedByVoucherAreYouSureModified: 'Đối tác này đã tạo chứng từ, xác nhận thay đổi?',
  duplicatePartnerCodeAlreadyExists: 'Mã đối tác bị trùng lặp, vui lòng kiểm tra lại!',
  partnerSameNameAlreadyExists: 'Đã tồn tại đối tác cùng tên, vui lòng kiểm tra tên tiếng Trung/Anh.',
  online: 'Trực tuyến',
  paper: 'Giấy tờ',
  carrierNotSelected: 'Chưa chọn nhà vận chuyển.',
  carrierAlreadyExists: 'Nhà vận chuyển đã tồn tại.',
  bookingMethodNotSelected: 'Chưa chọn phương thức đặt chỗ.',
  shortMessage: 'SMS',
  alreadyDefaultContact: 'Đã có liên hệ mặc định, lưu sẽ sử dụng liên hệ hiện tại làm mặc định',
  notSaveTwoDefaultContact: 'Không thể lưu hai liên hệ mặc định!',
  contactNameAndPhoneNumberCannotBlank: 'Tên liên hệ và số điện thoại không được để trống!',
  contactNameCannotBlank: 'Tên liên hệ không được để trống!',
  emailBlankOrFormatError: 'Email trống hoặc sai định dạng!',
  mobileBlankOrFormatError: 'Số điện thoại trống hoặc sai định dạng!',
  sameAirlineInvalidMsg: '{0} đã tồn tại 【{2}】 trùng lặp trong tuyến 【{1}】, vui lòng không thêm lại!',
  mailMode: 'Nhận email',
  phoneMode: 'Nhận SMS',
  syncContact: 'Đồng bộ dữ liệu với danh bạ đối tác',
  currentJob: 'Nghiệp vụ hiện tại',
  mobilePhoneNumberValidNumber: 'Số điện thoại chỉ được chứa chữ số hợp lệ',
  emailFormatError: 'Sai định dạng Email',
  emailLengthCannotExceed128Characters: 'Email không vượt quá 128 ký tự',
  phoneNumberLengthCannotExceed32Characters: 'Số điện thoại không vượt quá 32 ký tự',
  phoneNumberCannotLongerThan32Characters: 'Số điện thoại không vượt quá 32 ký tự',
  expenseFinancialDate: 'Ngày tài chính chi phí',
  dailySettlement: 'Thanh toán theo ngày',
  adjustContractInformationInBasicData: 'Quý công ty đã kích hoạt quản lý hợp đồng, vui lòng điều chỉnh thông tin tín dụng trong hợp đồng còn hiệu lực tại mục Dữ liệu cơ bản - Quản lý hợp đồng!',
  masterAgent: 'Đại lý chính',
  secondaryAgent: 'Đại lý cấp 2',
  billAddressCannotEmpty: 'Địa chỉ hóa đơn không được để trống!',
  nmsCannotEmpty: 'Quản trị mạng không được để trống!',
  firstPlease: 'Vui lòng trước tiên',
  selectImportFile: 'Chọn tệp nhập liệu:',
  fileSizeCannotExceed20m: 'Kích thước tệp không vượt quá 20M',
  startImport: 'Bắt đầu nhập liệu',
  emailAddress: 'Địa chỉ Email',
  specificContactEmailAddress: 'Địa chỉ Email liên hệ cụ thể',
  userCannotEmpty: 'Người dùng không được để trống!',
  destinationOperationAgentNotMaintained: 'Đại lý xử lý cảng đích chưa được thiết lập.',
  completeInputItems: 'Vui lòng điền đầy đủ thông tin nhập liệu',
  disassociateAndSaveModifications: 'Xác nhận hủy liên kết và lưu thay đổi?',
  alreadyDefaultBankInformation: 'Đã có thông tin ngân hàng mặc định, khi lưu sẽ sử dụng thông tin ngân hàng hiện tại làm giá trị mặc định',
  ordinary: 'Thông thường',
  supervise: 'Giám sát',
  warehousingRequirements: 'Yêu cầu nhập kho',
  alreadyDefaultWarehouse: 'Đã có kho mặc định, khi lưu sẽ sử dụng kho hiện tại làm kho mặc định',
  operateInMasterDataContractManagement: 'Công ty bạn đã được cấp quyền menu [Quản lý hợp đồng], vui lòng thao tác trong Cơ sở dữ liệu - Quản lý hợp đồng!',
  contract: 'Hợp đồng',
  effectiveAndExpirationDateCannotBlank: 'Ngày hiệu lực và ngày hết hạn không được để trống',
  fileDeletedSuccessfully: 'Xóa tệp thành công!',
  viewContactInformation: 'Xem thông tin liên hệ',
  lineAlreadyExistsAndCannotAddedRepeatedly: 'Tuyến đường này đã tồn tại, không thể thêm lặp lại',
  vendorCannotEmpty: 'Nhà cung cấp không được để trống!',
  confirmDeleteSupplyChainLine: 'Bạn có chắc chắn muốn xóa tuyến đường chuỗi cung ứng này không?',
  deleteSupplyChain: 'Xóa chuỗi cung ứng',
  emailAddress2: 'Địa chỉ email',
  setDefaultAutoSendMailbox: 'Đặt làm email tự động gửi mặc định',
  alreadyDefaultInvoicingHeader: 'Đã có tiêu đề hóa đơn mặc định, khi lưu sẽ sử dụng tiêu đề hóa đơn hiện tại làm giá trị mặc định',
  branchCannotBlank: 'Chi nhánh không được để trống.',
  cannotRepeat: 'Không được lặp lại.',
  bookingAgentNotSelected: 'Đại lý đặt chỗ chưa được chọn.',
  bookingAgentAlreadyExists: 'Đại lý đặt chỗ đã tồn tại.',
  defaultMarkupRange: 'Mức tăng giá mặc định',
  rateClass: 'Cước phí vận chuyển',
  batchSaveSucceeded: 'Lưu hàng loạt thành công',
  priceAdjustmentRecordUsedAndCannotDeleted: 'Đã sử dụng bản ghi điều chỉnh giá, không thể xóa.',
  deleteSucceeded: 'Xóa thành công!',
  selectAppointmentNumberToEdit: 'Vui lòng chọn số hợp đồng bạn muốn chỉnh sửa!',
  shipSecretaryAppointmentNumberCannotEmpty: 'Số hợp đồng hãng tàu không được để trống!',
  innerContractNoCannotEmpty: 'Số hợp đồng nội bộ không được để trống!',
  effectiveDateCannotBlank: 'Ngày hiệu lực không được để trống!',
  expirationDateCannotBlank: 'Ngày hết hạn không được để trống!',
  expirationDateMustGreaterEqualEffectiveDate: 'Ngày hết hạn phải lớn hơn hoặc bằng ngày hiệu lực!',
  defaultPriceIncreaseRangeCannotBlank: 'Mức tăng giá mặc định không được để trống!',
  selectRouteCorrespondingToDestinationPort: 'Vui lòng chọn tuyến đường tương ứng với cảng đích!',
  oneRecordWithoutRouteAndDestination: 'Chỉ được phép có một bản ghi không có tuyến đường và cảng đích!',
  sameRoute: 'Tuyến đường giống nhau',
  oneRecordCanGeneratedPleaseModify: 'Chỉ được phép tạo một bản ghi, vui lòng sửa đổi!',
  sameRouteAndDestination: 'Tuyến đường và cảng đích giống nhau',
  samePol: 'Cảng xếp hàng giống nhau',
  associatedRoute: 'Tuyến đường liên quan',
  isParentCompany: 'Có phải công ty mẹ không',
  isFba: 'Có phải FBA không',
  subsidiaryInformation: 'Thông tin công ty con',
  deleteSubsidiaryTips: 'Vui lòng đánh dấu công ty con muốn xóa!',
  deleteSubsidiaryConfirm: 'Sau khi xóa, mối quan hệ giữa công ty mẹ và công ty con sẽ bị hủy, bạn có muốn tiếp tục không?',
  changeParentCompany: 'Đã có công ty con liên quan, vui lòng hủy mối quan hệ với công ty con trước khi thao tác!',
  officeChangeForSubsidiaryCompany: 'Đã có công ty con liên quan, sau khi sửa đổi, công ty con khi chỉnh sửa công ty mẹ có thể không chọn được đối tác này, bạn có muốn tiếp tục không?',
  quota: 'Hạn mức',
  monthlySpecifiedDate: 'Ngày chỉ định hàng tháng',
  weeklySettlement: 'Thanh toán theo tuần',
  semilunarKnot: 'Kết toán nửa tháng',
  settlementDay: 'Thanh toán theo ngày',
  statementDate: 'Ngày hóa đơn',
  customerSupplierType: 'Loại đối tác',
  CustomerMailbox: 'Email khách hàng',
  WhetherToSendMailAutomatically: 'Có tự động gửi email không',
  DefaultMailSendingObject: 'Đối tượng nhận email mặc định',
  DefaultMailSendingObjectTip: 'Nếu địa chỉ email đối tượng nhận để trống sẽ gửi cho người tạo hóa đơn',
  BulkUpdateSurcharge: 'Cập nhật hàng loạt phụ phí',
  autoEmailSettings: 'Thiết lập gửi email tự động',
  taxControlPlatformSending: 'Gửi từ nền tảng thuế',
  systemAutomaticSending: 'Hệ thống tự động gửi',
  systemAutomaticSendingObject: 'Đối tượng nhận tự động từ hệ thống',
  taxControlPlatformSendingObject: 'Đối tượng nhận từ nền tảng thuế',
  partnerInvoiceReminder: 'Nền tảng thuế và hệ thống có thể gửi email riêng đến hộp thư chỉ định. Nếu bật tự động gửi nhưng địa chỉ email đối tượng nhận để trống sẽ gửi cho người tạo hóa đơn.',
  interestFreeCompany: 'Công ty miễn lãi',
  uniformRenewalSurcharge: 'Cập nhật đồng loạt phụ phí',
  lookSurcharge: 'Xem phụ phí',
  batchReplaceAfterSave: 'Lưu ý: Sau khi lưu sẽ thay thế hàng loạt phụ phí đã thiết lập trước đó, áp dụng cho tất cả tuyến đường thuộc giá trị hợp đồng này.',
  validityPeriodRepeatedAndCannotCopy: 'Hiệu lực trùng lặp, không thể sao chép',
  sameRoutePodPol: 'Cùng tuyến đường, cảng đi, cảng đến',
  sameRoutePol: 'Cùng tuyến đường và cảng đi',
  agreementContent: 'B5-03=giá trị thông số Ki, (cài 3)\n' +
    'B5-05=giá trị thông số Kd, (cài 2)\n' +
    '\n' +
    'Các bên A và B tuân theo mục đích "nâng cao hiệu quả, giảm liên kết, thúc đẩy phát triển, xác định rõ trách nhiệm và điều chỉnh hành vi" và theo các quy định của pháp luật và quy định liên quan của Nhà nước và thành phố Thượng Hải, các bên đã đạt được thỏa thuận sau đây liên quan đến việc Bên B sử dụng đặt phòng điện tử thông qua nền tảng CARGOWARE theo nguyên tắc "cùng có lợi và đồng thuận":\n' +
    '\n' +
    'Chương 1 - Quy Tắc Chung\n' +
    'Thỏa thuận này là thỏa thuận chung chính thức giữa Bên A và Bên B liên quan đến hoạt động xuất khẩu hàng hải thông qua nền tảng CARGOWARE theo phương thức đặt phòng điện tử được ủy quyền qua Tenant; Kể từ khi hai bên đồng ý với Thỏa thuận này trong phần chức năng ủy quyền của nền tảng CARGOWARE trên Tenant, nền tảng CARGOWARE được coi là thỏa thuận mà người dùng nền tảng đó đã đồng ý với trách nhiệm và nghĩa vụ của Thỏa thuận này;\n' +
    '2- Bên A thành lập công ty hoặc doanh nghiệp có tư cách pháp nhân độc lập có giấy phép kinh doanh hợp lệ và hoạt động hợp pháp trong phạm vi hoạt động được liệt kê trong giấy phép kinh doanh;\n' +
    '3. Bên B thành lập công ty hoặc doanh nghiệp có tư cách pháp nhân độc lập có giấy phép kinh doanh hợp lệ và hoạt động hợp pháp trong phạm vi hoạt động được liệt kê trong giấy phép kinh doanh;\n' +
    '4. Các bên A và B có được ID người dùng doanh nghiệp và Key (chữ ký dữ liệu điện tử) một cách hợp pháp sau khi đăng ký đánh giá thông qua nền tảng CARGOWARE. Bất kỳ hành động nào được thực hiện bởi các bên thông qua nền tảng dữ liệu CARGOWARE thông qua chữ ký dữ liệu điện tử này được coi là thể hiện ý nghĩa thực sự của các bên và xác nhận và sẵn sàng tự chịu mọi trách nhiệm và rủi ro phát sinh do đó;\n' +
    '5. Bên A đồng ý yêu cầu đặt chỗ với Bên B dưới hình thức vận đơn đặt chỗ trên giấy thay thế đặt chỗ điện tử được ủy quyền trên nền tảng Tenant và thay thế con dấu đặt chỗ dưới hình thức ID và Key của Tenant;\n' +
    '6. Bên B chấp nhận ủy quyền của bên A bằng cách trả lại đơn đặt hàng điện tử trên giấy thay thế được ủy quyền qua Tenant và xác nhận đơn đặt hàng dưới dạng ID và Key của Tenant; Bên B sẽ thay mặt A tiến hành phân phối, xếp hàng hóa xuất khẩu cho người vận chuyển hoặc đại lý của người vận chuyển theo các điều khoản quy định trong thỏa thuận kinh doanh liên quan của hai bên; Một loạt nghiệp vụ đại lý vận chuyển hàng hóa như vào kho, đóng thùng, đóng tàu......\n' +
    '7. Hai bên A và B áp dụng cơ chế quy trình đặt phòng điện tử và phương thức thực hiện do nền tảng đám mây dữ liệu ủy thác trước đó xây dựng, hai bên A và B đều điền ID Tenant của nhau vào mục chức năng này;\n' +
    'Các bên A và B có trách nhiệm ngăn chặn sự xâm nhập hoặc truyền tải bất hợp pháp và đảm bảo rằng các nhà khai thác gửi và nhận tương ứng có thẩm quyền hợp pháp để thực sự bảo vệ hồ sơ và dữ liệu kinh doanh khỏi sự xâm nhập, giả mạo hoặc phá hủy bất hợp pháp;\n' +
    '9. Bên B sau khi nhận được báo cáo yêu cầu đặt phòng điện tử ủy thác xuyên Tenant của Bên A, phải kịp thời gửi thư trả lời qua Nền tảng. Bên A phải luôn luôn quan tâm đến trạng thái đơn xin ủy thác đặt khoang điện tử của mình, nếu không nhận được thông tin xử lý của đối phương, bên A có nghĩa vụ nhanh chóng liên hệ và tìm kiếm nguyên nhân với bên B;\n' +
    'Khi các bên A và B không nhận được xác nhận trong một khoảng thời gian hợp lý đã thỏa thuận, các bên phải thực hiện các biện pháp tương ứng, nếu không các bên có quyền giả định rằng việc truyền tải ban đầu đã được nhận và Nền tảng CargoWare không chịu trách nhiệm về tính kịp thời và hiệu lực của việc chấp nhận của các bên;\n' +
    '11. Dữ liệu đặt phòng điện tử và thông tin trả lại được ủy quyền qua Tenant mà các bên A và B đáp ứng các yêu cầu của Quy tắc hoạt động của nền tảng có hiệu lực pháp lý tương đương với chứng từ bằng văn bản; Bên A có quyền truy đòi cước vận chuyển đối với hàng hóa do Bên B gửi.\n' +
    'Chương II Chi phí và thanh toán\n' +
    'Các bên A và B thực hiện các dịch vụ ủy thác nghiệp vụ liên quan đến đặt vé điện tử qua Tenant theo các điều khoản cụ thể của thỏa thuận giao nhận hàng hóa và thỏa thuận thanh toán chi phí liên quan mà các bên đã ký kết.\n' +
    'Chương 3: Quyền và nghĩa vụ của các bên\n' +
    'Nếu vì lý do của Bên A, việc bảo quản không tốt chữ ký dữ liệu điện tử do Nền tảng CargoWare cung cấp hoặc hoạt động ủy quyền không chặt chẽ dẫn đến việc người khác sử dụng hoặc sử dụng bất hợp pháp và thực hiện thao tác dữ liệu do Bên A chịu hậu quả tương ứng;\n' +
    '2. Thông điệp dữ liệu do Bên A gửi cho Bên B hoặc nội dung được nhập trực tuyến vào hệ thống điện tử của Bên A phải bao gồm, nhưng không giới hạn, thời gian chính xác của chuyến bay hoặc chuyến bay của tàu hàng không, tên của người vận chuyển, số vận đơn, số thỏa thuận, cảng đích, cảng dỡ hàng, chi tiết hàng hóa (tên, số lượng kiện, tổng trọng lượng, khối lượng, mô tả thuộc tính của hàng hóa, kích thước của hàng hóa đặc biệt, v.v.), điều khoản vận chuyển, khối lượng thùng chứa trước, người gửi hàng, người nhận hàng, người thông báo, dấu vận chuyển và các thông tin khác cần được ghi chú đặc biệt và được gửi theo hình thức nội dung thỏa thuận giữa các bên;\n' +
    '3. Đối với hàng hóa đặc biệt mà Bên A ủy quyền đặt hàng để vận chuyển, chẳng hạn như hàng nguy hiểm, hàng lạnh, hàng quá khổ, hàng hóa cần kiểm tra hộp hoặc hàng hóa cần hộp đặc biệt để mang, cũng như các hàng hóa đặc biệt khác phải cung cấp thư xác nhận bằng văn bản bằng giấy Bên A mới có thể chấp nhận đặt hàng của mình, chẳng hạn như tài liệu bản vẽ cho hàng hóa quá khổ và bằng chứng trước khi làm lạnh hộp lạnh, v.v. Đối với hàng hóa nguy hiểm cũng phải cung cấp tờ khai hàng hóa nguy hiểm trên giấy và giấy chứng nhận đóng gói hàng hóa nguy hiểm và chứng từ yêu cầu của người vận chuyển khác. Đối với một số hàng hóa cần trả tiền trước rồi mới đặt khoang, phải kịp thời trả tiền cho bên B, sau đó mới có thể chấp nhận đặt khoang;\n' +
    '4- Bên A phải khai báo trung thực thông tin thực tế về hàng hóa gửi hàng trong báo cáo đặt hàng điện tử, nếu bên A khai báo sai làm tổn hại đến lợi ích của bên B hoặc bên thứ ba, bên A phải chịu trách nhiệm bồi thường thiệt hại tương ứng;\n' +
    '5- Bên A nếu cần thay đổi thông tin ủy thác đặt hàng, phải thông báo cho bên B vào ngày hàng hóa được xếp vào container hoặc vào kho hàng tạp hóa; Bên A sẽ yêu cầu Bên B thay đổi bằng văn bản hoặc các hình thức khác theo thỏa thuận giữa các bên;\n' +
    '6. Bên A có nghĩa vụ thanh toán cước vận chuyển, phụ phí và các chi phí khác theo thời gian thỏa thuận đối với hàng hóa do Bên B ủy thác vận chuyển thông qua đặt vé điện tử;\n' +
    '7. Bên A nếu đã đặt vận đơn ủy thác cần hoàn thuế, phải kịp thời thông qua văn bản hoặc hình thức khác mà hai bên thỏa thuận, nếu không bên B chịu toàn bộ trách nhiệm và chi phí phát sinh.\n' +
    '8. Bên B nhận được đơn đặt hàng điện tử ủy thác xuyên Tenant do Bên A gửi phải kịp thời xác nhận việc chấp nhận hoặc từ chối đơn đặt hàng của Bên B dưới dạng dữ liệu điện tử trong một khoảng thời gian hợp lý;\n' +
    '9. Do sự cố bất thường trong mạng lưới, mạng công cộng hoặc nền tảng CARGOWARE của riêng mình, các bên sẽ sử dụng phương pháp đặt chỗ giấy truyền thống để tiến hành kinh doanh đặt chỗ và truyền thông tin trong thời gian này.\n' +
    'Chương 4: Xác nhận đặt phòng điện tử\n' +
    '1- Bên B sau khi nhận được báo cáo dữ liệu đặt phòng điện tử của bên A cần xử lý kịp thời trong thời gian hợp lý, phải gửi thư xác nhận chấp nhận ủy thác hoặc từ chối theo yêu cầu của nền tảng, từ chối phải nêu rõ lý do từ chối;\n' +
    '2- Bên A chỉ có thể coi là Bên B đã chấp nhận ủy thác đặt phòng của Bên A sau khi Bên B trả lại xác nhận nhận lại báo cáo đặt phòng điện tử đã nhận ủy thác;\n' +
    'Nếu Bên A tiến hành một loạt các hoạt động trước khi Bên B không xác nhận mà chỉ có thể thực hiện sau khi Bên B chấp nhận đặt phòng của Bên A thì hành vi này được coi là vi phạm và mọi trách nhiệm pháp lý và rủi ro phát sinh do Bên A chịu;\n' +
    '4. Bên B sẽ thay mặt người vận chuyển chấp nhận ủy thác đặt chỗ của Bên A và thực hiện các hoạt động vận tải xuất khẩu liên quan theo nội dung và yêu cầu của việc xác nhận đặt chỗ và không có hành động nào của Bên B theo Thỏa thuận này có thể được coi là cam kết hoặc bảo đảm đối với việc xác nhận việc đặt chỗ thành công của đơn hàng.\n' +
    'Chương V: Thực hiện thỏa thuận\n' +
    '1. Các bên A và B phải thực hiện nghiêm túc các nội dung liên quan được quy định trong Thỏa thuận và Điều khoản này.\n' +
    '2. Không bên ký kết thỏa thuận nào có thể chuyển nhượng lợi ích theo Thỏa thuận này cho các cá nhân hoặc tổ chức không liên quan khác.\n' +
    '3. Bất kỳ bên tham gia thỏa thuận nào, trong việc thực hiện các nghĩa vụ của mình theo Thỏa thuận này, phải thông báo cho bên kia kịp thời vì bất khả kháng không thể thực hiện hoặc không thể thực hiện đúng thời hạn các vấn đề liên quan đến Thỏa thuận và cố gắng áp dụng các biện pháp khác. Các bên tham gia thỏa thuận mà thông báo dữ liệu bị trì hoãn, rò rỉ hoặc sai trong thời gian này sẽ không chịu trách nhiệm về hậu quả không mong muốn trong thời gian đó.\n' +
    'Nếu một bên tham gia thỏa thuận phát hiện hành vi vi phạm an ninh, sử dụng bất hợp pháp hoặc bất hợp pháp, họ phải thông báo ngay cho bên kia và các bên liên quan khác và tiến hành điều tra, báo cáo kết quả điều tra cho bên kia và các bên liên quan khác. Trong thời gian này, dữ liệu điện tử nên tạm thời dừng lại cho đến khi tình hình an ninh trở lại bình thường.\n' +
    'Trong trường hợp hai bên ký kết Thỏa thuận giao nhận vận tải, Thỏa thuận này là phụ lục của Thỏa thuận này và được thực hiện một phần chưa đầy đủ theo các điều khoản liên quan của Thỏa thuận giao nhận vận tải.\n' +
    'Chương VI: Thay đổi và chấm dứt thỏa thuận\n' +
    '1. Không bên nào trong Thỏa thuận này có thể thay đổi và hủy bỏ Thỏa thuận mà không có ý định. Nếu có lý do đặc biệt không thể tiếp tục thực hiện hoặc cần thay đổi thì phải có sự đồng ý của các bên khác và tiến hành các thủ tục thay đổi hoặc chấm dứt thỏa thuận trong thời hạn quy định của thỏa thuận. Nếu đề xuất ngoài thời hạn quy định trong thỏa thuận, bên kia phải gánh chịu thiệt hại thực tế đã gây ra.\n' +
    'Khi các bên đạt được thỏa thuận chấm dứt Thỏa thuận này, các bên sẽ loại bỏ sự đồng ý và xóa thông tin cấu hình liên quan trên các mục chức năng ủy quyền Tenant trên nền tảng CARGOWARE.\n' +
    'Chương 7: Trách nhiệm vi phạm\n' +
    'Các bên vi phạm thỏa thuận phải bồi thường thiệt hại thực tế gây ra cho bên kia theo hành vi này.\n' +
    'Chương 8 - Khác\n' +
    'Do bất kỳ tranh chấp nào phát sinh từ Hiệp định này, các bên sẽ giải quyết trước bằng thương lượng trên nguyên tắc cùng có lợi và nếu không có thương lượng, sẽ bị kiện ra tòa án hàng hải tại địa phương nơi các bên đăng ký hoạt động.',
  SuccessSyncCloudAndStarrySky: 'Đồng bộ hóa mây sao thành công',
  FailSyncCloudAndStarrySky: 'Đồng bộ hóa mây sao thất bại, {0}',
  HMSyncYongYouSuccess: 'Dữ liệu khách hàng đồng bộ với bạn bè thành công. msg"{0}"',
  HMSyncYongYouFail: 'Đồng bộ hóa dữ liệu khách hàng không thành công, {0}',
  HMSyncYongYouSuccess2: 'Dữ liệu nhà cung cấp đồng bộ hóa với bạn bè thành công. msg"{0}"',
  HMSyncYongYouFail2: 'Đồng bộ hóa dữ liệu nhà cung cấp thất bại, {0}',
  bankEnglishName: 'Tên ngân hàng (tiếng Anh)',
  bankAddress: 'Địa chỉ ngân hàng',
  bankEnglishAddress: 'Địa chỉ ngân hàng (tiếng Anh)',
  EidtBranchNotSameTip: 'Vui lòng chuyển chi nhánh ở góc trên bên phải sang công ty liên kết của đối tác này để thực hiện thao tác chỉnh sửa nhất quán.',
  BranchNoPartnerPermission: 'Hiện tại chi nhánh không có đối tác biên tập có thẩm quyền!',
  DeleteBranchNotSameTip: 'Vui lòng chuyển chi nhánh ở góc trên bên phải sang công ty liên kết của đối tác này để thực hiện thao tác xóa phù hợp.',
  operateBranchNotSameTip: 'Tạm thời không có quyền hành động, xin vui lòng chuyển công ty chi nhánh ở góc trên bên phải sang đối tác hợp tác này sau khi nhất trí với công ty thuộc công ty của mình mới tiến hành thao tác.',
  BranchNoDeletePartnerPermission: 'Chi nhánh hiện tại không có quyền xóa đối tác!',
  MergeBranchNotSameTip: 'Vui lòng chuyển chi nhánh ở góc trên bên phải sang công ty con của đối tác này để hợp nhất hoạt động.',
  BranchNoMergePartnerPermission: 'Chi nhánh hiện tại không có quyền hợp nhất đối tác!',
  UnifiedSign: 'Có ký hay không',
  IfRisk: 'Khách hàng mạo hiểm',
  customerCode: 'Mã khách hàng',
  supplierCode: 'Mã hóa nhà cung cấp',
  customerCodeNotSupportChinese: 'Mã khách hàng không được nhập vào Trung Quốc',
  supplierCodeNotSupportChinese: 'Mã nhà cung cấp không thể nhập vào Trung Quốc',
  customersAndSuppliersMustChooseOne: 'Khách hàng và nhà cung cấp phải chọn một',
  CustomerCodeNotEmpty: 'Mã khách hàng không được phép để trống',
  SupplierCodeNotEmpty: 'Mã nhà cung cấp không được phép để trống',
  CustomerCodeCheck: 'Mã hóa khách hàng thế hệ mới không đúng định dạng, vui lòng nhập 【13 chữ số】',
  SupplierCodeCheck: 'Định dạng mã hóa của nhà cung cấp thế hệ mới không chính xác, vui lòng nhập 【ABCD Bất kỳ chữ cái+7 chữ số】',
  CcGroup: 'Nhóm CC',
  CcAddress: 'Địa chỉ CC',
  ccAgentOverseaOp: 'CC ĐL DVKHNN',
  UseEmailGroup: 'Nhóm email',
  PartnersApprovedTips: 'Dữ liệu được chọn hiện tại bao gồm các mục đã được phê duyệt không thể chỉnh sửa, vui lòng bỏ chọn trước khi tiếp tục',
  isInternalCorrespondent: 'Có phải công ty nội bộ không',
  internalCorrespondent: 'Công ty nội bộ',
  batchAddServer: 'Thêm hàng loạt nhân viên dịch vụ',
  batchAddServerNoSelected: 'Vui lòng chọn đối tác để thêm nhân viên dịch vụ',
  batchAddServerConfigError: 'Đối tác bạn chọn không hỗ trợ bảo trì nhân viên dịch vụ',
  addServicePersonnel: 'Thêm nhân viên dịch vụ',
  BookingAgentLevel: 'Cấp độ đại lý đặt chỗ',
  bookingAgentLevelNotSelected: 'Chưa chọn cấp độ đại lý đặt chỗ',
  Underestimation: 'Tính nợ',
  IfAdvancePayment: 'Thanh toán trước',
  CreditRemarks: 'Giải thích bổ sung về tín dụng',
  DefaultSettlementForInsurance: 'Đối tượng thanh toán mặc định bảo hiểm',
  DriverInformation: 'Thông tin tài xế',
  DriverName: 'Tên tài xế',
  DriverPhoneNumber: 'Số điện thoại tài xế',
  PlateNumber: 'Biển số xe',
  IdentityCard: 'Số CMND',
  DriverNameRequired: 'Tên tài xế bắt buộc',
  CreditUnit: 'Đơn vị hạn mức',
  creditDateUnit: 'Đơn vị kỳ hạn',
  b2bDisplay: 'B2B có hiển thị không'
}
